if (!customElements.get('price-component')) {
  class PriceComponent extends HTMLElement {
    constructor() {
      super();
      this.price = this.querySelector('[data-price]');
      this.type = this.dataset.type ? this.dataset.type.split(',') : ['one-time'];
      this.compareAtPrice = this.querySelector('[data-compare-at-price]') || null;
    }

    connectedCallback() {
      document.addEventListener('price:changed', (event) => {
        if (!this.type.includes(event.detail.type)) return;

        if (this.price) this.price.querySelector('span').innerHTML = event.detail.price;
        if (this.compareAtPrice) {
          if (event.detail.compareAtPrice && event.detail.compareAtPrice != event.detail.price) {
            this.compareAtPrice.innerHTML = event.detail.compareAtPrice;
            this.compareAtPrice.classList.remove('hidden');
          } else {
            this.compareAtPrice.classList.add('hidden');
          }
        }
      });
    }
  }

  customElements.define('price-component', PriceComponent);
}
